import { render } from "./PersonalData.vue?vue&type=template&id=18b80fa4&scoped=true&ts=true"
import script from "./PersonalData.vue?vue&type=script&lang=ts"
export * from "./PersonalData.vue?vue&type=script&lang=ts"

import "./PersonalData.vue?vue&type=style&index=0&id=18b80fa4&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b80fa4"]])

export default __exports__